export default {
  US_CENTRAL_1: "us-central1", // Iowa
  US_EAST_1: "us-east1", // (South Carolina)
  US_EAST_4: "us-east4", // (Northern Virginia)
  EUROPE_WEST_1: "europe-west1", //(Belgium)
  EUROPE_WEST_2: "europe-west2", // (London)
  ASIA_EAST_2: "asia-east2", // (Hong Kong)
  ASIA_NORTHEAST_1: "asia-northeast1", //(Tokyo)
};
